LeftNav = require '../../left_nav/frontend/main'
ProductReviews = require '../../product_reviews/frontend/main'
PartialRenderer = require './partial_renderer'

$(window).load ->
  Groupon.Performance.pageReady()
  payload = Groupon.Utils.getConfigFromDom()
  new LeftNav()
  new PartialRenderer payload
  new ProductReviews payload
